export default __webpack_public_path__ + "static/media/pokeball-logo.63d54d2b.png";